import { axios } from '@/plugins/axios';

export function getRegimeCaisse(codeRegime: string, codeCaisse: string, codeCentre: string) {
	return axios.get('/aat-api/regimecaisse/libelle', { params: { codeRegime, codeCaisse, codeCentre } });
}

export function getIsConnecte(codeRegime: string, codeCaisse: string) {
	return axios.get('/aat-api/regimecaisse/connecte', { params: { codeRegime, codeCaisse } });
}
